import { useState, useEffect } from "react";
import { useAuth, API } from "@/App";
import axios from "axios";
import { toast } from "sonner";
import { Gift, Copy, Check, Users, Volume2 } from "lucide-react";

export const ReferralCard = () => {
  const { token } = useAuth();
  const [info, setInfo] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/referral/info`, { headers: { Authorization: `Bearer ${token}` } });
        setInfo(data);
      } catch { /* silent */ }
    })();
  }, [token]);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(info.link);
      setCopied(true);
      toast.success("Referral link copied!");
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error("Could not copy"); }
  };

  if (!info) return null;

  return (
    <div data-testid="referral-card" className="card-omni p-8">
      <h2 className="font-heading text-xl font-medium mb-1 flex items-center gap-2">
        <Gift className="w-5 h-5 text-rose-500" strokeWidth={1.5} /> Invite Friends, Earn Voice
      </h2>
      <p className="text-sm text-muted-foreground mb-4">
        When a friend you invite becomes a paid subscriber, you get a <strong>free month of Voice 100</strong> — every single time.
      </p>
      <div className="flex items-center gap-2 mb-4">
        <code data-testid="referral-link" className="flex-1 px-3 py-2.5 rounded-xl bg-muted text-xs truncate">{info.link}</code>
        <button
          data-testid="copy-referral-btn"
          onClick={copyLink}
          className="px-4 py-2.5 rounded-xl bg-primary text-primary-foreground text-xs font-medium flex items-center gap-1.5 hover:opacity-90 transition-opacity"
        >
          {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />} {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <div className="flex items-center gap-6 text-xs text-muted-foreground">
        <span className="flex items-center gap-1.5"><Users className="w-3.5 h-3.5" /> {info.invited} invited</span>
        <span className="flex items-center gap-1.5"><Gift className="w-3.5 h-3.5" /> {info.converted} subscribed</span>
        {info.active_reward_until && (
          <span data-testid="referral-reward-active" className="flex items-center gap-1.5 text-emerald-600 font-medium">
            <Volume2 className="w-3.5 h-3.5" /> Voice 100 active until {info.active_reward_until.slice(0, 10)}
          </span>
        )}
      </div>
    </div>
  );
};
